/*
  rein-delivery-estimate-2026-09-26
  Calculated, labelled delivery windows for the product buy block
  (snippets/rein-delivery-estimate.liquid). the owner approved calendar-date
  estimates 2026-09-26; every number below comes from
  ops/shipping/shipping-facts.md and nowhere else.

  Brand ranges, in business days:
    Brondell       handling 2-3   s3 dealer price list "Lead Time: 2-3 business days"
                   transit  1-5   s8 FedEx Ground, contiguous US
    Crystal Quest  handling 4-5   s3 terms page normal handling, "within 4 - 5 days" (not
                                   the outer "not later than 7 - 10 business days" case)
                   transit  1-5   s8 UPS Ground, contiguous US
    Waterdrop      handling 1-2   s3 service policy "24 to 48 hours to prepare your order"
                   transit  3-6   s3 service policy, Standard 3-6 business days
  WaterWorld USA and The Water Machine have no sourced handling figure
  (s3 "Handling: not published"; s2 measured n=3 and n=1, marked
  insufficient data), so they get no date.

  Processing is our own commitment, s12: order submitted to the manufacturer
  within 2 business days. Earliest = 0 + min handling + min transit;
  latest = 2 + max handling + max transit. Business days skip weekends and
  US federal holidays (observed dates). Clock is US Eastern; an order after
  2pm ET, or on a weekend or holiday, starts the next business day.

  ⚠️ The transit figures must stay in step with the brand table in
  templates/page.shipping.json and the accordion in
  sections/rein-product-support.liquid. Change all three together.

  Loaded by the storefront and by scripts/test-delivery-estimate.js (Node).
*/
(function (root) {
  var RANGES = {
    'Brondell': { handling: [2, 3], transit: [1, 5], akhi: false },
    'Crystal Quest': { handling: [4, 5], transit: [1, 5], akhi: true },
    'Waterdrop': { handling: [1, 2], transit: [3, 6], akhi: true }
  };
  var PROCESSING = [0, 2];
  var CUTOFF_MINUTES = 14 * 60;
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function utc(y, m, d) { return new Date(Date.UTC(y, m, d)); }
  function key(dt) { return dt.toISOString().slice(0, 10); }
  function addDays(dt, n) { return utc(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate() + n); }

  function nthWeekday(y, m, weekday, n) {
    var first = utc(y, m, 1);
    var offset = (weekday - first.getUTCDay() + 7) % 7;
    return utc(y, m, 1 + offset + (n - 1) * 7);
  }
  function lastWeekday(y, m, weekday) {
    var last = utc(y, m + 1, 0);
    return utc(y, m, last.getUTCDate() - ((last.getUTCDay() - weekday + 7) % 7));
  }
  function observed(dt) {
    var wd = dt.getUTCDay();
    if (wd === 6) return addDays(dt, -1);
    if (wd === 0) return addDays(dt, 1);
    return dt;
  }

  var holidayCache = {};
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var list = [
      observed(utc(y, 0, 1)),
      nthWeekday(y, 0, 1, 3),
      nthWeekday(y, 1, 1, 3),
      lastWeekday(y, 4, 1),
      observed(utc(y, 5, 19)),
      observed(utc(y, 6, 4)),
      nthWeekday(y, 8, 1, 1),
      nthWeekday(y, 9, 1, 2),
      observed(utc(y, 10, 11)),
      nthWeekday(y, 10, 4, 4),
      observed(utc(y, 11, 25))
    ];
    var set = {};
    list.forEach(function (dt) { set[key(dt)] = true; });
    holidayCache[y] = set;
    return set;
  }
  function isHoliday(dt) {
    var y = dt.getUTCFullYear();
    var k = key(dt);
    return !!(holidays(y)[k] || holidays(y + 1)[k]);
  }
  function isBusinessDay(dt) {
    var wd = dt.getUTCDay();
    return wd !== 0 && wd !== 6 && !isHoliday(dt);
  }
  function nextBusinessDay(dt) {
    var d = addDays(dt, 1);
    while (!isBusinessDay(d)) d = addDays(d, 1);
    return d;
  }
  function addBusinessDays(dt, n) {
    var d = dt;
    for (var i = 0; i < n; i++) d = nextBusinessDay(d);
    return d;
  }

  function easternParts(now) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(now).forEach(function (p) { parts[p.type] = p.value; });
    return {
      y: +parts.year, m: +parts.month - 1, d: +parts.day,
      minutes: (+parts.hour % 24) * 60 + (+parts.minute)
    };
  }

  function startDay(now) {
    var et = easternParts(now);
    var today = utc(et.y, et.m, et.d);
    if (isBusinessDay(today) && et.minutes < CUTOFF_MINUTES) return today;
    return nextBusinessDay(today);
  }

  function label(dt) {
    return DAYS[dt.getUTCDay()] + ', ' + MONTHS[dt.getUTCMonth()] + ' ' + dt.getUTCDate();
  }

  function windowFor(vendor, now) {
    var r = RANGES[vendor];
    if (!r) return null;
    var start = startDay(now || new Date());
    var early = addBusinessDays(start, PROCESSING[0] + r.handling[0] + r.transit[0]);
    var late = addBusinessDays(start, PROCESSING[1] + r.handling[1] + r.transit[1]);
    return {
      start: key(start), earliest: key(early), latest: key(late),
      text: label(early) + ' – ' + label(late), akhi: r.akhi
    };
  }

  function show(el, on) { if (el) el.hidden = !on; }

  function paint(box, variantId) {
    var variants = {};
    try { variants = JSON.parse(box.getAttribute('data-variants') || '{}'); } catch (e) {}
    var v = variants[String(variantId)];
    var date = box.querySelector('[data-eta-date]');
    var freight = box.querySelector('[data-eta-freight]');
    var akhi = box.querySelector('[data-eta-akhi]');
    if (!v || !v[0]) { box.hidden = true; return; }
    box.hidden = false;
    if (v[1]) { show(date, false); show(akhi, false); show(freight, true); return; }
    show(freight, false);
    var w = windowFor(box.getAttribute('data-vendor'));
    if (!w) { show(date, false); show(akhi, false); return; }
    box.querySelector('[data-eta-range]').textContent = w.text;
    show(date, true);
    show(akhi, w.akhi);
  }

  function init() {
    var boxes = document.querySelectorAll('[data-rein-eta][data-variants]');
    if (!boxes.length) return;
    boxes.forEach(function (box) { paint(box, box.getAttribute('data-current')); });
    document.addEventListener('product:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      boxes.forEach(function (box) { paint(box, v.id); });
    });
  }

  var api = { windowFor: windowFor, isBusinessDay: isBusinessDay, holidays: holidays, RANGES: RANGES, PROCESSING: PROCESSING };
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.ReinDelivery = api;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }
})(this);
